import React, { useState, useEffect } from 'react'
import { Row, Table, ButtonGroup, IconButton, Icon } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'
const { Column, HeaderCell, Cell } = Table

export default function UpdateListAttachFilesTable({
  data,
  deleteEnable,
  onPreview = () => {},
  onDownload = () => {},
  onDelete = () => {},
  ...props
}) {
  const [filelist, setFilelist] = useState([])

  useEffect(() => {
    setFilelist(data || [])
  }, [data])

  return (
    <Row style={{ marginBottom: '2em' }}>
      <Table
        autoHeight={filelist.length <= 10 ? true : false}
        minHeight={250}
        height={filelist.length <= 10 ? undefined : 610}
        wordWrap
        bordered
        data={filelist}
      >
        <Column width={90} align="center" fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column minWidth={300} flexGrow={1}>
          <HeaderCell>ชื่อไฟล์</HeaderCell>
          <Cell dataKey="label" />
        </Column>

        <Column width={deleteEnable ? 150 : 100} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <IconButton
                    appearance="ghost"
                    size="sm"
                    icon={<Icon icon="eye" className="bt-gost-icon-radius-all" />}
                    onClick={(e) => onPreview(rowData)}
                    disabled={!rowData?.path}
                    style={{ marginRight: 5 }}
                  />
                  <IconButton
                    appearance="ghost"
                    size="sm"
                    icon={<Icon icon="download" className={'bt-gost-icon-radius-all'} />}
                    onClick={(e) => onDownload(rowData)}
                    disabled={!rowData?.path}
                    style={{ marginRight: 5 }}
                  />
                  {deleteEnable && (
                    <IconButton
                      appearance="ghost"
                      size="sm"
                      className="rs-btn-ghost-cancel"
                      icon={
                        <Icon
                          icon="trash"
                          className="bt-gost-icon-radius-all-cancel"
                          style={{ border: '4px' }}
                        />
                      }
                      onClick={(e) => onDelete(rowData)}
                      disabled={!rowData?.path}
                      style={{ marginRight: 5 }}
                    />
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Row>
  )
}
